export const getCaseStudyLink = (title: string): string =>
  `/case-studies/${title.replace(/\s/g, '-').toLowerCase()}`;
